import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import LiveClass from '../../domain/services/bbb/meeting/Index';

const initialState = {
  loading: 'idle',
  response: {},
  error: '',
};

export const studentGetMyLiveClasses = createAsyncThunk(
  'student-get-classes-by-id',
  async function (user_id: string) {
    return new LiveClass().getClassStudents({
      user_id,
    });
  }
);

const getMyLiveClassesStudent = createSlice({
  name: 'get_my_live_classes',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(studentGetMyLiveClasses.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(studentGetMyLiveClasses.fulfilled, (state, action) => {
      state.loading = 'success';
      state.response = action.payload.live_classes;
    });
    builder.addCase(studentGetMyLiveClasses.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const exportState = state => state.getMyLiveClassesStudent;

export const studentCreateLiveClassState = createSelector(exportState, obj => {
  return {
    responseStudents: obj.response,
    loadingStudents: obj.loading,
  };
});

export default getMyLiveClassesStudent.reducer;
